// extracted by mini-css-extract-plugin
export var printerCard = "_b0-1";
export var printerCardConfigured = "_b0-2";
export var printerCardError = "_b0-3";
export var printerCardsContainer = "_b0-0";
export var printerIcon = "_b0-8";
export var printerIconConfigured = "_b0-5";
export var printerIconContainer = "_b0-4";
export var printerIconError = "_b0-6";
export var printerIconUnconfigured = "_b0-7";
export var workstationsTableCard = "_b0-9";